import { LargeSiteScreenNewRunModal } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenNewRunModal";
import { PlusOutlined } from "@ant-design/icons";
import { useLocalStorage } from "@mantine/hooks";
import { Button, Modal } from "antd";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";

/**
 * Header for the Portfolio Export tool's table.
 */
export const LargeSiteScreenTableHeader = ({
  actionBtns
}: any) => {
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(Object.keys(router.query).includes("handoff"));
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "screening.largeSite"
  });
  const [showBetaModal, setShowBetaModal] = useLocalStorage<"not-viewed" | "viewed">({
    key: "lssBetaModalClosed",
    defaultValue: "not-viewed",
    getInitialValueInEffect: false
  });
  return <>
      <div className="flex w-full items-center justify-between pb-4">
        <div className="flex w-full items-center justify-start gap-2">{actionBtns}</div>
        <div className="flex w-full items-center justify-end gap-2">
          <Link href="/tools/create/lss-from-map" passHref data-sentry-element="Link" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
            <Button type="primary" icon={<PlusOutlined />} data-sentry-element="Button" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
              {t("startNewRun")}
            </Button>
          </Link>
        </div>
      </div>

      <LargeSiteScreenNewRunModal open={isModalOpen} onCancel={() => setIsModalOpen(false)} onRunStart={() => setIsModalOpen(false)} data-sentry-element="LargeSiteScreenNewRunModal" data-sentry-source-file="LargeSiteScreenTableHeader.tsx" />
      <Modal title="NEW Large Site Screen Tool" open={showBetaModal === "not-viewed"} onCancel={() => setShowBetaModal("viewed")} footer={null} data-sentry-element="Modal" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
        <Markdown className="prose" data-sentry-element="Markdown" data-sentry-source-file="LargeSiteScreenTableHeader.tsx">
          {`
The Large Site Screen Tool was recently launched and we are actively collecting feedback to improve this feature. If you encounter any issues or have suggestions on how we might improve this tool, please share your thoughts via our feedback form. Your input is highly valuable and will help shape future updates.
`}
        </Markdown>
      </Modal>
    </>;
};